import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-lg text-background-50">
                  美女视频推荐
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                精选高清美女短视频App推荐平台，为您提供最优质的美女视频App下载推荐和深度评测内容。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/re-men-tui-jian" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热门推荐</Link></li>
                <li><Link to="/category/yan-zhi-zhu-bo" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">颜值主播</Link></li>
                <li><Link to="/category/wu-dao-cai-yi" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">舞蹈才艺</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">更多分类</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/category/chuan-da-shi-shang" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">穿搭时尚</Link></li>
                <li><Link to="/category/sheng-huo-ri-chang" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">生活日常</Link></li>
                <li><Link to="/category/zui-xin-shang-xian" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">最新上线</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>contact@beautyvideo.app</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 美女视频推荐. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}